// src/features/records/components/MapView/components/LoadingDots.js
import styles from './LoadingDots.module.css';

const LoadingDots = ({ isVisible = false }) => {
  if (!isVisible) return null;

  return (
    <div className={styles.container}>
      <div className={styles.spinner}>
        <span className={styles.spinnerDot}></span>
        <span className={styles.spinnerDot}></span>
        <span className={styles.spinnerDot}></span>
      </div>
    </div>
  );
};

export default LoadingDots;